import { useEffect, useState } from 'react';
import type { AdminMetricsResponse } from '@reims-local/types';
import { adminApi } from '../lib/api';

export function Dashboard() {
  const [metrics, setMetrics] = useState<AdminMetricsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .metrics()
      .then((res) => setMetrics(res.data))
      .catch((err) => setError(String((err as Error).message)));
  }, []);

  if (error) return <div className="alert alert-error">Erreur : {error}</div>;
  if (!metrics) return <p>Chargement…</p>;

  return (
    <>
      <h2>Dashboard</h2>
      <div className="grid-kpi">
        <Kpi label="Boutiques actives" value={metrics.active_shops} />
        <Kpi label="En attente / pré-inscrites" value={metrics.pending_shops} />
        <Kpi label="Trial" value={metrics.trial_shops} />
        <Kpi label="Suspendues" value={metrics.suspended_shops} />
        <Kpi label="Invitations envoyées" value={metrics.invitations_sent} />
        <Kpi label="Comptes activés" value={metrics.invitations_activated} />
        <Kpi label="Commandes 30j" value={metrics.orders_30d} />
        <Kpi label="GMV 30j" value={`${(metrics.gmv_cents_30d / 100).toFixed(2)} €`} />
      </div>
    </>
  );
}

function Kpi({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
    </div>
  );
}
